export default {
	0: "App",
	1: "Sales",
};
